import SessionsDelete from "./SessionsDelete";
export default SessionsDelete;
